import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { CategoriesSelectionComponent } from './components/categories-selection/categories-selection.component';
import { CustomCardComponent } from './components/cards/custom-card/custom-card.component';
import { NewsLargeCardComponent } from './components/cards/news-large-card/news-large-card.component';
import { NewsSmallCardComponent } from './components/cards/news-small-card/news-small-card.component';
import { ReactionsComponent } from './components/cards/reactions/reactions.component';
import { UniversoAhorramasCardComponent } from './components/cards/universo-ahorramas-card/universo-ahorramas-card.component';
import { CustomHeaderComponent } from './components/custom-header/custom-header.component';
import { QuestionAnswerDropdownComponent } from './components/dropdowns/question-answer-dropdown/question-answer-dropdown.component';
import { FooterDesktopComponent } from './components/footer-desktop/footer-desktop.component';
import { FooterMobileComponent } from './components/footer-mobile/footer-mobile.component';
import { NavBarComponent } from './components/nav-bar/nav-bar.component';
import { OrderByComponent } from './components/order-by/order-by.component';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { PaginationComponent } from './components/pagination/pagination.component';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { NotificationsComponent } from './notifications/components/notifications.component';
import { ProfileComponent } from '../features/profile/profile.component';
import { SafeUrlPipe } from '../pipes/safe-url.pipe';
import { MainCategoryPipe } from '../pipes/get-main-category.pipe';
import { ModalComponent } from './components/modal/modal.component';

@NgModule({
  declarations: [
    CategoriesSelectionComponent,
    CustomCardComponent,
    CustomHeaderComponent,
    FooterDesktopComponent,
    FooterMobileComponent,
    NavBarComponent,
    NewsLargeCardComponent,
    NewsSmallCardComponent,
    NotificationsComponent,
    OrderByComponent,
    PageNotFoundComponent,
    PaginationComponent,
    ProfileComponent,
    QuestionAnswerDropdownComponent,
    ReactionsComponent,
    SpinnerComponent,
    UniversoAhorramasCardComponent,
    SafeUrlPipe,
    MainCategoryPipe,
    ModalComponent
  ],
  imports: [
    CommonModule,
    RouterModule
  ],
  exports: [
    CategoriesSelectionComponent,
    CommonModule,
    CustomCardComponent,
    CustomHeaderComponent,
    FooterDesktopComponent,
    FooterMobileComponent,
    NavBarComponent,
    NewsLargeCardComponent,
    NewsSmallCardComponent,
    NotificationsComponent,
    OrderByComponent,
    PageNotFoundComponent,
    PaginationComponent,
    ProfileComponent,
    QuestionAnswerDropdownComponent,
    ReactionsComponent,
    SpinnerComponent,
    UniversoAhorramasCardComponent,
    SafeUrlPipe,
    MainCategoryPipe,
    ModalComponent
  ],
  providers: [MainCategoryPipe]
})
export class SharedModule { }
